module.exports = __webpack_public_path__ + "static/media/market.6b8e2ce7.png";